import moment from 'moment-timezone';
import { GRAPH_DATETIME_FORMAT } from './timeConstants';

export const isYesterday = (date: Date): boolean => {
  return (
    moment().subtract(1, 'day').format('DD dddd') ===
    moment(date, GRAPH_DATETIME_FORMAT).format('DD dddd')
  );
};
